import '../../modules/setup/views/createAccount/createAccount';
import '../../modules/setup/views/forgotPassword/forgotPassword';
import '../../modules/setup/views/orgRegistration/orgRegistration';
import '../../modules/setup/views/setPassword/setPassword';
import BrandingService from '../../services/branding.service';
var page = 'login-container-view';
var view = 'login-view';

var params = {
    page: page,
    view: view,
    level: 'login'
};
let newVar = [
    { url: '', params: params },
    { url: 'login', params: { page: page, view: view } },
    { url: 'login/sso', params: { page: page, view: view } },
    { url: 'login/onecloud', params: { page: page, view: view } },
    { url: 'login/onecloud/{email}', params: { page: page, view: view } },
    { url: 'login/{email}/{password}:?query:', params: params },
    { url: 'login/su/{token}/{username}', params: params },
    { url: 'login/su/{token}/{username}/{orgId}', params: params },
    { url: 'login/su/{token}/{username}/url/{url*}', params: params },
    { url: 'login/su/{token}/{username}/{orgId}/url/{url*}', params: params },
    { url: 'login/{token}/{username}/url/{url*}', params: params },
    { url: 'login/{token}/{username}/{orgId}/url/{url*}', params: params },
    { url: 'logout', params: { page: page, view: 'logout-view' } }
];
if (BrandingService.getAllowForgotPassword()) {
    newVar.push({ url: 'login/forgotPassword', params: { page: 'forgot-password-view', view: 'forgot-password-view' } });
    newVar.push({ url: 'setPassword/{token}', params: { page: 'set-password-view', view: 'set-password-view' } });
}
if (BrandingService.getAllowCreateAccount()) {
    newVar.push({ url: 'login/createAccount', params: { page: 'create-account-view', view: 'create-account-view' } });
    newVar.push({ url: 'orgRegistration/{email}/{token}', params: { page: 'org-registration-view', view: 'org-registration-view' } });
    newVar.push({ url: 'register/{email}/{registrationCode}', params: { page: 'password-setup-container-view', view: 'password-setup-view' } });
}
export default newVar;
